export const UPDATE_PLC_SAFETY_EVENT = 'UPDATE_PLC_SAFETY_EVENT';
export const UPDATE_PLC_SAFETY_EVENT_SUCCESSFUL = 'UPDATE_PLC_SAFETY_EVENT_SUCCESSFUL';
export const UPDATE_PLC_SAFETY_EVENT_FAILED = 'UPDATE_PLC_SAFETY_EVENT_FAILED';
